<script lang="ts">
  import Card from "@kontextwerk/web-sdk/ui/layout/Card.svelte"
  import ChartCanvas from "@kontextwerk/web-sdk/ui/charts/components/ChartCanvas.svelte"
  import { doughnutShare } from "@kontextwerk/web-sdk/core/charts/presets/doughnut"
  import { resolveChartTheme } from "@kontextwerk/web-sdk/core/charts/theme/resolveTheme"
  import type { HomeDashboardWorkOrderStatusShare } from "../../../../../../../../../../../../api/kehrblatt/home-dashboard"
  import { hasActiveWorkOrderStatusShare } from "../../../../../../../../_shared/_logic/home-dashboard"

  const { rows }: { rows: HomeDashboardWorkOrderStatusShare[] } = $props()

  const ChartCanvasView: any = ChartCanvas
  const chartRows = $derived(rows.filter((row) => Number(row.count ?? 0) > 0))
  const hasData = $derived(hasActiveWorkOrderStatusShare(rows))
  let chartScope = $state<HTMLElement | null>(null)
  const theme = $derived(resolveChartTheme(chartScope, { variant: "dark" }))
  const chartConfig = $derived(
    doughnutShare({
      labels: chartRows.map((row) => row.label),
      values: chartRows.map((row) => Number(row.count ?? 0)),
      label: "Aktive Aufträge",
      theme,
      colors: ["#00ce5d", "#005282", "#7a52d6", "#e07a00", "#e03f65", "#6b7280"],
      legendPosition: "bottom",
    }),
  )
</script>

<div class="chart-card" bind:this={chartScope}>
  <Card>
    {#snippet contentSnippet()}
      <div class="chart-card__header">
        <h4>Auftragslage</h4>
        <small>Aktive Aufträge</small>
      </div>
      {#if hasData}
        <div class="chart-card__canvas">
          <ChartCanvasView
            config={chartConfig}
            height={240}
            ariaLabel="Aktive Aufträge nach Status"
          />
        </div>
      {:else}
        <div class="chart-empty">Keine aktiven Aufträge vorhanden.</div>
      {/if}
    {/snippet}
  </Card>
</div>

<style lang="less">
  .chart-card {
    display: flex;
    flex-direction: column;
  }

  .chart-card__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.2rem;
    margin: 0.2rem 0 0.85rem;
    text-align: center;
  }

  .chart-card__header h4 {
    margin: 0;
    font-size: 14px;
    font-weight: 800;
    color: var(--text-100);
  }

  .chart-card__header small {
    letter-spacing: 0;
    color: color-mix(in srgb, var(--text-100) 78%, transparent);
    font-size: 10px;
    font-weight: 700;
  }

  .chart-card__canvas {
    position: relative;
    height: 240px;
  }

  .chart-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    color: color-mix(in srgb, var(--text-100) 70%, transparent);
    text-align: center;
    line-height: 1.4;
  }
</style>
